import { inject, Injectable, linkedSignal, signal } from '@angular/core';
import { StorageService } from '@shared/services/storage.service';
import { StorageKey } from '@shared/enums';
import { MinorApplicationOverview } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class MinorOverviewStateService {
  private readonly _storageService = inject(StorageService);

  private readonly _overview = signal<MinorApplicationOverview | null>(
    this._storageService.read(StorageKey.minorOverview) ?? null,
  );

  private readonly _minorApplicationId = linkedSignal(
    () => this.overview()?.id ?? null,
  );

  public readonly overview = this._overview.asReadonly();
  public readonly minorApplicationId = this._minorApplicationId.asReadonly();

  public setOverview(overview: MinorApplicationOverview) {
    this._overview.set(overview);
  }
  public setMinorApplicationId(id: number | null) {
    this._minorApplicationId.set(id);
  }
}
